import firebase from 'firebase/app'
import'firebase/auth';
export default {
  methods: {
    checkSignInWithEmailLink: function() {
      const vueObj = this
      // Confirm the link is a sign-in with email link.
      if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
        // Additional state parameters can also be passed via URL.
        // This can be used to continue the user's intended action before triggering
        //console.log(" isSignInWithEmailLink returned true : ", window.location.href)
        // the sign-in operation.
        // Get the email if available. This should be available if the user completes
        // the flow on the same device where they started it.
        var email = window.localStorage.getItem('emailForSignIn');
        if (!email) {
          // User opened the link on a different device. To prevent session fixation
          // attacks, ask the user to provide the associated email again. For example:
          email = window.prompt('Please provide your email for confirmation');
        }
        // The client SDK will parse the code from the link for you.
        firebase.auth().signInWithEmailLink(email, window.location.href)
          .then((result) => {
            // Clear email from storage.
            window.localStorage.removeItem('emailForSignIn');
            // You can access the new user via result.user
            // Additional user info profile not available via:
            //console.log(" Sign in with email link result : ",result)
            vueObj.$store.dispatch("commitUser",result.user)
            // You can check if the user is new or existing:
            // result.additionalUserInfo.isNewUser
            //vueObj.$router.replace("UPP") // could go to home page but why not go to UPP 
            if (vueObj.$route.path != "/") {
              console.log("3 router push /")
              vueObj.$router.push("/") // could go to home page but why not go to UPP 
            } else console.log("avoided 3 router push /")
        })
        .catch((error) => {
            // Some error occurred, you can inspect the code: error.code
            // Common errors could be invalid email and invalid or expired OTPs.
          console.log("sign in with Email Link error : ",error)
        });
      } else {
        console.log(" isSignInWithEmailLink returned false : ", window.location.href)
      }
    },


    sendOneTimeEmailVerification: function() {
      //const actionCodeSettings = {
        // URL you want to redirect back to. The domain (www.example.com) for this
        // URL must be in the authorized domains list in the Firebase Console.
      //  url: vueObj.$store.getters.frontEndServerURL,
        // This must be true.
      //  handleCodeInApp: true,
      //};
      //console.log("Sending email to : ", vueObj.email)
      //firebase.auth().sendSignInLinkToEmail(vueObj.email, actionCodeSettings)
        console.log( JSON.stringify({ email: this.email, url: this.$store.getters.frontEndServerURL })) 

      fetch('https://us-central1-' + process.env.VUE_APP_FIREBASE_PROJECT_ID + '.cloudfunctions.net/sendVerificationEmail', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: this.email, url: this.$store.getters.frontEndServerURL }), 
      })
        .then((response) => {
          if (response.ok) {
            // The link was successfully sent. Inform the user.
            // Save the email locally so you don't need to ask the user for it again
            // if they open the link on the same device.
            window.localStorage.setItem('emailForSignIn', this.$store.getters.user.email);
            //console.log("storing email to localStorage : ", vueObj.email)
            console.log('Email sent successfully');
          } else {
            console.error('Error sending email');
          }
        })
        .catch((error) => {
          console.error('Error sending email:', error);
        });

    },
  }
};